class BlockKeyNumbersImage {

	constructor(){

		let blocks = document.querySelectorAll('.block-key-numbers-image');

		blocks.forEach( (block) => {
			let keys = block.querySelector('.keys');
			let keysItem = keys.querySelectorAll('li');

			ScrollTrigger.create({
				trigger: keys,
				start: "top 75%",
				end: 99999,
				onEnter: () => {
					keys.classList.add("appeared");
				}
			});

			keysItem.forEach( (key, index) => {

				ScrollTrigger.create({
					trigger: key,
					start: "top 75%",
					end: 99999,
					onEnter: () => {
						key.classList.add("appeared");
					}
				});

				const splitTimeline = gsap.timeline({
					scrollTrigger: {
						trigger: key,
						start: "top 75%",
						end: "bottom 0%",
					}
				});

				splitTimeline.from(key.querySelectorAll('.number span span, .label span span'), {
					duration: 1.5,
					yPercent: 150,
					ease: "power4",
					stagger: 0.15,
					autoAlpha: 0
				});
			});
		});

	}

}
